import { IgTooltip } from "@intelligems/ig-theme";
import IconButton from "@mui/material/IconButton";
import { useDialogs } from "@src/hooks/dialog";
import { Sparkle } from "@src/images/Icons/Sparkle";
import { useSelector } from "@src/store";
import { selectAiTestNameState } from "@src/store/slices/global";

interface AiTestNameSparkleProps {
  experienceId: string;
  experienceName: string;
}

export const AiTestNameSparkle = ({
  experienceId,
  experienceName,
}: AiTestNameSparkleProps) => {
  const { openDialog } = useDialogs();
  const aiTestNameState = useSelector(selectAiTestNameState(experienceId));

  if (
    aiTestNameState?.status !== "ready" ||
    !aiTestNameState.flaggedNames.some(
      (f) => f.nameType === "test_name" && f.currentValue !== f.originalName
    )
  ) {
    return null;
  }

  return (
    <IgTooltip title="AI name suggestion">
      <IconButton
        size="small"
        onClick={() =>
          openDialog("testNameReviewDialog", { experienceId, experienceName })
        }
      >
        <Sparkle variant="purple" />
      </IconButton>
    </IgTooltip>
  );
};
